import React from 'react';
import { Box, VStack, Button, Image, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'; // Importamos useNavigate

// Tus importaciones de SVG como componentes de React
import LogoTea from "../../assets/tea-logoVersion.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UpgradeCard from './UpgradePlan';


const SidebarButton = ({ icon, label, route }) => {
  const { pathname } = window.location;
  const Navigate = useNavigate();

  const grayColor = useColorModeValue('#BDBDBD', 'whiteAlpha.600');
  const activeColor = '#90BCB5';

  let isActive = pathname === route || pathname.includes(route);

  return (
    <Button
      leftIcon={<FontAwesomeIcon icon={icon} color={isActive ? activeColor : grayColor} />}
      variant="ghost"
      justifyContent="flex-start"
      alignItems="center"
      iconSpacing="4"
      aria-label={label}
      onClick={() => Navigate(route)} // Utilizamos la función onClick pasada como prop
      sx={{
        color: isActive ? activeColor : grayColor, // Make active if isActive
        fontFamily: "Poppins",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: isActive ? "700" : "500",
        lineHeight: "normal",
        transition: "all 0.3s",
        _hover: {
          color: activeColor,
          fontWeight: "700",
        },
        _active: {
          color: activeColor,
          fontWeight: "700",
        },
        _focus: {
          boxShadow: 'none',
          color: activeColor,
          fontWeight: "700",
        },
        '.chakra-button__icon': {
          color: isActive ? activeColor : grayColor, // Make active if isActive
        }
      }}
      rightIcon={
        isActive && (
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="4" r="4" fill="#90BCB5" />
          </svg>
        )
      }
    >
      {label}
    </Button>
  );
};

const LeftParentSidebar = () => {
  const logoStyles = {
    width: "145px",
    height: "66px",
    marginBottom: "2rem"
  };

  const sidebarStyles = {
    width: "240px",
    bg: "white",
    p: "5",
    borderRight: "2px solid #F0F0F0"
  };

  return (
    <Box w="240px" bg="white" p="5" position="relative" h="100vh" {...sidebarStyles}>
      <div className='h-full flex flex-col justify-between'>
        <VStack align="stretch" spacing="4">
          <div className='w-full flex justify-center'>
            <Box sx={logoStyles}>
              <Image src={LogoTea} alt="Logo Tea" marginTop="20px" marginBottom="20px" align="center" />
            </Box>
          </div>
          {/* Navegación directa en cada botón sin pasar props */}
          <SidebarButton icon="fas fa-house" label="Home" route='/Dashboard' />
          {/* <SidebarButton icon="fas fa-chart-simple" label="Reports" route='/Reports' /> */}
          <SidebarButton icon="fas fa-folder" label="Blogs" route='/Blog' />
          <SidebarButton icon="fas fa-comment-dots" label="FAQs" route='/Faq' />
          <SidebarButton icon="fas fa-gear" label="Settings" route='/Settings' />

        </VStack>
        <UpgradeCard />
      </div>
    </Box>
  );
};

export default LeftParentSidebar;
